import { useCallback, useEffect, useState } from "react";
import { useAuthed } from "../../lib/adminApi";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { toast } from "sonner";

function ExtraRow({ ex, onSave }) {
  const [name, setName] = useState(ex.name);
  const [price, setPrice] = useState(String(ex.price));
  const dirty = name !== ex.name || Number(price) !== ex.price;
  return (
    <div className="flex flex-wrap items-center gap-2 bg-white rounded-xl border border-gray-100 p-3" data-testid={`extra-row-${ex.id}`}>
      <Input value={name} onChange={(e) => setName(e.target.value)} className="flex-1 min-w-[160px]" data-testid={`extra-name-${ex.id}`} />
      <div className="flex items-center gap-1 text-sm text-gray-500">KSh<Input type="number" value={price} onChange={(e) => setPrice(e.target.value)} className="w-24" data-testid={`extra-price-${ex.id}`} /></div>
      <label className="flex items-center gap-2 text-xs text-gray-600">
        <Switch checked={ex.available} onCheckedChange={(v) => onSave(ex, { available: v })} data-testid={`extra-available-${ex.id}`} /> Available
      </label>
      <Button size="sm" disabled={!dirty || !(Number(price) > 0)} onClick={() => onSave(ex, { name, price: Number(price) })} className="mlobox-gradient text-white rounded-full" data-testid={`extra-save-${ex.id}`}>Save</Button>
    </div>
  );
}

export default function ExtrasManager() {
  const call = useAuthed();
  const [extras, setExtras] = useState([]);
  const load = useCallback(async () => {
    try { const r = await call("get", "/admin/extras"); setExtras(r.data); } catch { toast.error("Could not load extras"); }
  }, [call]);
  useEffect(() => { load(); }, [load]);

  const save = async (ex, patch) => {
    try { await call("patch", `/admin/extras/${ex.id}`, patch); toast.success(`${patch.name || ex.name} updated`); load(); }
    catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || "Could not save"); }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="font-display font-extrabold text-xl sm:text-2xl mb-1">Meal extras</h1>
      <p className="text-sm text-gray-500 mb-4">Paid add-ons customers can pick on a meal. Choose which meals offer each extra in the dish editor.</p>
      <div className="space-y-2">
        {extras.map((ex) => <ExtraRow key={`${ex.id}-${ex.price}-${ex.name}`} ex={ex} onSave={save} />)}
      </div>
    </div>
  );
}
